export const pscblack = '#0D1529';
export const blue1 = '#29235C';
export const blue2 = '#4E74E0';
export const blue3 = '#85A2FD';
export const fuchsia = '#974040';
export const magenta = '#F34768';
export const green1 = '#409797';
export const green2 = '#47f3d2';
export const roofOrange = '#FF9577';
export const sunYellow = '#F7B033';
export const yellow2 = '#FFE2B2';
export const white = '#FFFFFF';
